// Single source of truth for the backend API base URL.
// Falls back to same-origin relative '/api' (correct behind the platform ingress)
// instead of localhost, so a missing env var can never point users at a dev URL.
export const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;
